import axiosInstance, {
  axiosInstanceV3,
  axiosInstanceCachedV3,
  deleteCacheV3,
} from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';
import Configuration from '@/utils/configuration';

//* V3 ===================================================================
//* v3 login
export const v3Login = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/auth/tg`, payload);
    // console.log('response:', response);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* initiate user exists check with phone/email
// @ payload has phone: +12345566 with country code info or email: test@test.com
export const userExists = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/v3/user_exists`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* initiate user verification with phone/email
// @ payload has phone: +12345566 or email: test@test.com
// @ optional pass: reset_password: true if doing password reset
export const userVerification = async (payload) => {
  // const NUXT_API_BASE = Configuration.value('VUE_APP_NUXT_API_BASE_URL');
  // console.log('process.env:', process.env);
  // console.log('NUXT_API_BASE:', NUXT_API_BASE);

  let response = {};

  // console.log('userVerification url:', `${NUXT_API_BASE}/api/auth/user-verification-create`);
  // console.log('userVerification url:', `http://localhost:3000/api/auth/user-verification-create`);

  try {
    response = await axiosInstance.post(`/v3/user_verification_create`, payload);
    // response = await axiosInstance.post(
    //   `${NUXT_API_BASE}/api/auth/user-verification-create`,
    //   // `http://localhost:3000/api/auth/user-verification-create`,
    //   payload
    // );
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* initiate user verification login with code and phone/email
// @ payload has phone: +12345566 or email: test@test.com
// @ optional pass: id as the token id in the url
// @ optional pass: reset_password: as the new password value
export const userVerificationLogin = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/v3/user_verification_login`, payload);
    await deleteCacheV3(axiosInstanceCachedV3, true, 'v3_get_me');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Send game client token to server for client login websocket
// @ payload has game_client_token: abc123
export const gameClientLogin = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/game_client_login`, payload);
    // console.log('gcl response:', response);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
